import { call, put } from 'redux-saga/effects';
import { requestGetClient, requestGetClients, requestGetClientBillingEntities, requestGetClientAccounts, requestCreateClient, requestUpdateClient, requestActivateClient, requestDeactivateClient, requestDeleteClient, requestRestoreClient, requestGetUnbilledCharges, requestAddClientDocument, requestUpdateClientDocument, requestDeleteClientDocument, requestRequestClientDocumentCopy, requestGetClientDocuments, requestGetClientDocumentScopes, requestGetClientDocumentTypes, requestAddClientDocumentChange, requestUpdateClientDocumentChange, requestDeleteClientDocumentChange, requestContactClient, requestGetClientFixedPriceRates, requestSetClientFixedPriceRate } from '../requests/client';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';
import { setRetainerStatus } from '../../slices/retainerStatus';

export function* handleGetClient(action) {
    try {
        const { clientId, callback } = action.payload;
        const response = yield call(requestGetClient, clientId);
        if (response.data?.retainerStatus) {
            yield put(setRetainerStatus({ key: `client:${response.data._id}`, status: response.data.retainerStatus }));
        }
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetClients(action) {
    try {
        const { start, limit, onSuccess, options } = action.payload;
        const response = yield call(requestGetClients, start, limit, options);
        if (onSuccess) {
            onSuccess(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload.onSuccess) action.payload.onSuccess(null);
    }
}

export function* handleGetClientBillingEntities(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetClientBillingEntities);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) {
            action.payload.callback(null);
        }
    }
}

export function* handleGetClientAccounts(action) {
    try {
        const { clientId, onSuccess } = action.payload;
        const response = yield call(requestGetClientAccounts, clientId);
        if (onSuccess) {
            onSuccess(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload.onSuccess) action.payload.onSuccess(null);
    }
}

export function* handleCreateClient(action) {
    try {
        const { client, callback } = action.payload;
        const response = yield call(requestCreateClient, client);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleUpdateClient(action) {
    try {
        const { clientId, updates, callback } = action.payload;
        const response = yield call(requestUpdateClient, clientId, updates);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleActivateClient(action) {
    try {
        const { clientId, callback } = action.payload;
        const response = yield call(requestActivateClient, clientId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleDeactivateClient(action) {
    try {
        const { clientId, callback } = action.payload;
        const response = yield call(requestDeactivateClient, clientId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleDeleteClient(action) {
    try {
        const { clientId, callback } = action.payload;
        const response = yield call(requestDeleteClient, clientId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleRestoreClient(action) {
    try {
        const { clientId, callback } = action.payload;
        const response = yield call(requestRestoreClient, clientId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleAddClientDocument(action) {
    try {
        const { clientId, document, callback } = action.payload;
        const response = yield call(requestAddClientDocument, clientId, document);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload.callback) action.payload.callback(null);
    }
}

export function* handleUpdateClientDocument(action) {
    try {
        const { clientId, docId, updates, callback } = action.payload;
        const response = yield call(requestUpdateClientDocument, clientId, docId, updates);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload.callback) action.payload.callback(null);
    }
}

export function* handleDeleteClientDocument(action) {
    try {
        const { clientId, docId, callback } = action.payload;
        const response = yield call(requestDeleteClientDocument, clientId, docId);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload.callback) action.payload.callback(null);
    }
}

export function* handleRequestClientDocumentCopy(action) {
    try {
        const { clientId, docId, callback } = action.payload;
        const response = yield call(requestRequestClientDocumentCopy, clientId, docId);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload.callback) action.payload.callback(null);
    }
}

export function* handleGetClientDocuments(action) {
    try {
        const { params, callback } = action.payload;
        const response = yield call(requestGetClientDocuments, params);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetClientDocumentScopes(action) {
    try {
        const { clientId, search, callback } = action.payload;
        const response = yield call(requestGetClientDocumentScopes, clientId, search);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetClientDocumentTypes(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetClientDocumentTypes);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleAddClientDocumentChange(action) {
    try {
        const { clientId, docId, change, callback } = action.payload;
        const response = yield call(requestAddClientDocumentChange, clientId, docId, change);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleUpdateClientDocumentChange(action) {
    try {
        const { clientId, docId, changeId, updates, callback } = action.payload;
        const response = yield call(requestUpdateClientDocumentChange, clientId, docId, changeId, updates);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleDeleteClientDocumentChange(action) {
    try {
        const { clientId, docId, changeId, callback } = action.payload;
        const response = yield call(requestDeleteClientDocumentChange, clientId, docId, changeId);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleContactClient(action) {
    try {
        const { clientId, data, callback } = action.payload;
        const response = yield call(requestContactClient, clientId, data);
        if (callback) callback(response.data);
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetUnbilledCharges(action) {
    try {
        const { clientId, callback } = action.payload;
        const response = yield call(requestGetUnbilledCharges, clientId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload.callback) {
            action.payload.callback(null);
        }
    }
}

export function* handleGetClientFixedPriceRates(action) {
    const { callback } = action.payload || {};
    try {
        const response = yield call(requestGetClientFixedPriceRates);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleSetClientFixedPriceRate(action) {
    const { clientId, fixedPriceRate, callback } = action.payload;
    try {
        const response = yield call(requestSetClientFixedPriceRate, clientId, fixedPriceRate);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}
